export const SUBJECT_PAPERS = [
  {
    subjectCode: "physical_sciences",
    paperCode: "physical_sciences_p1",
    paperNumber: 1,
    icon: "⚛️",
    name: {
      en: "Physical Sciences Paper 1",
      af: "Fisiese Wetenskappe Vraestel 1",
    },
    focus: {
      en: "Physics",
      af: "Fisika",
    },
    tutorAvailable: true,
    exam: {
      totalMarks: 150,
      durationMinutes: 180,
      questionCount: 10,
      templateId:
        "DBE_GRADE_12_PHYSICAL_SCIENCES_PAPER_1_2025_PATTERN",
    },
  },
  {
    subjectCode: "physical_sciences",
    paperCode: "physical_sciences_p2",
    paperNumber: 2,
    icon: "🧪",
    name: {
      en: "Physical Sciences Paper 2",
      af: "Fisiese Wetenskappe Vraestel 2",
    },
    focus: {
      en: "Chemistry",
      af: "Chemie",
    },
    tutorAvailable: true,
    exam: {
      totalMarks: 150,
      durationMinutes: 180,
      questionCount: 9,
      templateId:
        "DBE_GRADE_12_CHEMISTRY_PAPER_2_2025_PATTERN",
    },
  },
  {
    subjectCode: "life_sciences",
    paperCode: "life_sciences_p1",
    paperNumber: 1,
    icon: "🧬",
    name: {
      en: "Life Sciences Paper 1",
      af: "Lewenswetenskappe Vraestel 1",
    },
    focus: {
      en: "Life processes and environmental responses",
      af: "Lewensprosesse en omgewingsreaksies",
    },
    tutorAvailable: true,
    exam: {
      totalMarks: 150,
      durationMinutes: 150,
      questionCount: 3,
      templateId:
        "DBE_GRADE_12_LIFE_SCIENCES_PAPER_1_2025_PATTERN",
    },
  },
  {
    subjectCode: "life_sciences",
    paperCode: "life_sciences_p2",
    paperNumber: 2,
    icon: "🧬",
    name: {
      en: "Life Sciences Paper 2",
      af: "Lewenswetenskappe Vraestel 2",
    },
    focus: {
      en: "Genetics and evolution",
      af: "Genetika en evolusie",
    },
    tutorAvailable: true,
    exam: {
      totalMarks: 150,
      durationMinutes: 150,
      questionCount: 3,
      templateId:
        "DBE_GRADE_12_LIFE_SCIENCES_PAPER_2_2025_PATTERN",
    },
  },
  {
    subjectCode: "mathematics",
    paperCode: "mathematics_p1",
    paperNumber: 1,
    icon: "📐",
    name: {
      en: "Mathematics Paper 1",
      af: "Wiskunde Vraestel 1",
    },
    focus: {
      en: "Algebra, functions, finance, calculus and probability",
      af: "Algebra, funksies, finansies, calculus en waarskynlikheid",
    },
    tutorAvailable: true,
    exam: {
      totalMarks: 150,
      durationMinutes: 180,
      questionCount: 11,
      templateId:
        "DBE_GRADE_12_MATHEMATICS_PAPER_1_2025_PATTERN",
    },
  },
  {
    subjectCode: "mathematics",
    paperCode: "mathematics_p2",
    paperNumber: 2,
    icon: "📊",
    name: {
      en: "Mathematics Paper 2",
      af: "Wiskunde Vraestel 2",
    },
    focus: {
      en: "Statistics, analytical geometry, trigonometry and geometry",
      af: "Statistiek, analitiese meetkunde, trigonometrie en meetkunde",
    },
    tutorAvailable: false,
    exam: {
      totalMarks: 150,
      durationMinutes: 180,
      questionCount: 11,
      templateId:
        "DBE_GRADE_12_MATHEMATICS_PAPER_2_2025_PATTERN",
    },
  },
];

export function getSubjectPaper(paperCode) {
  return SUBJECT_PAPERS.find(
    (subjectPaper) =>
      subjectPaper.paperCode === paperCode
  ) || null;
}

export function summariseSubjectPaperResults(
  results = []
) {
  return SUBJECT_PAPERS.map((subjectPaper) => {
    const paperResults = results.filter(
      (result) =>
        result.paperCode ===
        subjectPaper.paperCode
    );

    const averagePercentage =
      paperResults.length > 0
        ? Math.round(
          paperResults.reduce(
            (total, result) =>
              total +
              Number(result.percentage || 0),
            0
          ) / paperResults.length
        )
        : null;

    return {
      ...subjectPaper,
      completedPapers: paperResults.length,
      averagePercentage,
    };
  });
}
